import React from 'react'
import { useTranslation } from 'react-i18next'
import { TableCell, TableRow } from '@mui/material'
import { formatDateYYYYMMDD } from '../../../../packages/utils/numberFormatters'
import { CompanyShare } from 'types/CompanyEntity'

interface ListedHistoryTableRowProps {
    date: string | null
    share: CompanyShare
    locale: string
    multipleInstrumentsExists?: boolean
    isSmallScreen: boolean
}

export const ListedHistoryTableRow = ({
    date,
    share,
    locale,
    multipleInstrumentsExists = false,
    isSmallScreen,
}: ListedHistoryTableRowProps) => {
    const { t } = useTranslation()

    return (
        <TableRow>
            <TableCell>{formatDateYYYYMMDD(date, { locale })}</TableCell>
            {multipleInstrumentsExists && !isSmallScreen ? <TableCell>{share.symbol}</TableCell> : null}
            <TableCell>
                {t('pages.companies.history.listingOf', {
                    name: share.nameChanges[0]?.fromName || share.instrumentName,
                })}
            </TableCell>
            {!isSmallScreen ? (
                <>
                    <TableCell />
                    <TableCell />
                </>
            ) : null}
            <TableCell />
        </TableRow>
    )
}
